import Vue from 'vue'
import Router from 'vue-router'
import MyVpn from '@/components/myvpn'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'myvpn',
      component: MyVpn
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js